export class RegisterModel {
    Id: number;
    Name: string = "";
    Username:string = "";
    FirstName: string = "";
    LastName: string = "";
    Email: string = "";
    Password: string = "";
    ConfirmPassword: string = "";
}